






































































































import Vue from 'vue'
import CCategoryPicker from '~/components/shared/configurable/category/picker/CCategoryPicker.vue'
import { TreeLevelCategory } from '~/models/category/types'
import CAutocompleteInput from '~/components/shared/configurable/form/autocomplete/CAutocompleteInput.vue'
import CategorySearchService, {
  CategoryId
} from '~/services/category/CategorySearchService'
import { PropType } from '@nuxtjs/composition-api'
import { useUrl } from '~/compositions/url'
import CExternalLinkMediatorModal from '~/components/shared/configurable/modal/CExternalLinkMediatorModal.vue'
import { debounce } from '~/utils/function'
import { DEBOUNCE_SLOW } from '~/constants/debounce'

export default Vue.extend({
  components: {
    CExternalLinkMediatorModal,
    CCategoryPicker,
    CAutocompleteInput
  },

  props: {
    title: { type: String, default: '' },
    rootCategoryId: { type: Number, required: true },
    searchbarOnly: { type: Boolean, default: false },
    searchbarPlaceholder: { type: String, default: null },
    suggestionsWithHeaders: { type: Boolean, default: true },
    showJobsLink: {
      type: Boolean,
      required: false,
      default: false
    },
    showPlotLink: {
      type: Boolean,
      required: false,
      default: false
    },
    siblingIds: {
      type: Array as PropType<CategoryId[]>,
      required: false,
      default() {
        return []
      }
    }
  },
  setup() {
    const { urlIsExternal } = useUrl()
    return {
      urlIsExternal
    }
  },
  data() {
    const { query, params } = this.$router.currentRoute
    return {
      categoryId: parseInt(query.cid as string, 10) || this.rootCategoryId,
      isLoading: !this.searchbarOnly,
      pickerLoader: false,
      externalLinkMediatorUrl: '',
      showExternalLinkMediatorModal: false,
      suggestions: [],
      query: '',
      selectedSuggestionId:
        parseInt(query.cid as string, 10) ||
        parseInt(params.categoryId as string, 10) ||
        null,
      hiddenLevelIndex: 0,
      fetchCategoriesLoading: false
    }
  },
  computed: {
    dangerMsg() {
      return this.$i18n.t(
        'if you do not choose the <b>right</b> category, they will not find your ad and we have the right to <b> delete it</b>.'
      )
    }
  },
  watch: {
    '$route.query.cid'(cid: string) {
      if (cid) {
        const catId = parseInt(cid, 10)
        this.categoryId = catId
      }
    }
  },
  methods: {
    handleCategoryChange(treeCategory: TreeLevelCategory) {
      if (treeCategory.id === -1 && this.$router.currentRoute?.query?.cid) {
        const query = {
          ...this.$router.currentRoute.query
        }
        delete query.cid
        this.$router.replace({
          ...this.$router.currentRoute,
          query
        })
      } else if (
        this.categoryId !== treeCategory.id &&
        treeCategory.id !== -1 &&
        !treeCategory.isRecent
      ) {
        this.$router.replace({ query: { cid: treeCategory.id } })
      }
      this.categoryId = treeCategory.id
    },
    handleSelectCategory(treeCategory: TreeLevelCategory) {
      if (!treeCategory.hasChildren) {
        // this.$router.push(`/parts/new/${treeCategory.id}/`)
        window.location.href = `/parts/new/${treeCategory.id}/`
      } else if (!this.searchbarOnly) {
        this.$router.replace({ query: { cid: treeCategory.id } })
      }
    },
    handleLoad(categoryTree: object) {
      if (!categoryTree) {
        this.hiddenLevelIndex = null
      } else {
        this.hiddenLevelIndex = 0
      }
      this.isLoading = false
      this.pickerLoader = false
      if (this.$refs?.categoryPicker?.$refs?.categoryLevel) {
        this.$nextTick(() =>
          this.$refs.categoryPicker.$refs.categoryLevel.forEach(cl =>
            cl.checkAndScrollToSelectedElement()
          )
        )
      }
    },

    fetchCategoryGroupsWithDebounce: debounce(function(query: string) {
      this.fetchCategoryGroups(query, this.rootCategoryId)
    }, DEBOUNCE_SLOW),

    handleInputChange(query: string) {
      this.fetchCategoryGroupsWithDebounce(query)
      setTimeout(() => (this.fetchCategoriesLoading = true), DEBOUNCE_SLOW)
    },

    autocompleteStop() {
      this.fetchCategoryGroups('', this.rootCategoryId)
    },
    handleSuggestionSelect(suggestionId: string) {
      // The refs under used to close the suggestions on press enter
      this.$refs.cAutocompleteInput.selectOpen = false
      this.$refs.cAutocompleteInput.$refs.carzillaAutocompleteInput.blur()
      if (this.selectedSuggestionId === parseInt(suggestionId, 10)) {
        return
      }
      this.selectedSuggestionId = suggestionId
      let selectedSuggestion = this.suggestions.find(s => s.id === suggestionId)
      if (selectedSuggestion.header && this.suggestions.length > 1) {
        selectedSuggestion = this.suggestions[1]
        this.selectedSuggestionId = this.suggestions[1].id
      }

      const categoryId = this.categoryId.toString()

      if (
        suggestionId &&
        categoryId !== this.selectedSuggestionId &&
        !this.selectedSuggestionId.match(/cnoData/)
      ) {
        this.pickerLoader = true
        const { targetUrl, category } = selectedSuggestion
        if (
          targetUrl?.match('http') ||
          !category.path.some(
            c => c.id.toString() === this.rootCategoryId.toString()
          )
        ) {
          if (this.urlIsExternal(targetUrl, true)) {
            // this is an external link so show the modal
            this.externalLinkMediatorUrl = targetUrl
            this.showExternalLinkMediatorModal = true
          } else {
            window.location.href = targetUrl
          }
        } else {
          this.$emit('suggestion-select', selectedSuggestion)
        }
      }
    },
    onInputFocus(query: string) {
      if (!query && !this.suggestions.length) {
        this.fetchCategoryGroups(query, this.rootCategoryId)
      }
    },
    async fetchCategoryGroups(query: string, rootCategoryId: number) {
      const categorySearchService = this.$dep(CategorySearchService)
      try {
        this.suggestions = await categorySearchService.fetchCategoryGroups(
          query,
          rootCategoryId,
          this.siblingIds || []
        )
      } catch (error) {
        this.$logger.captureError(error)
      } finally {
        this.fetchCategoriesLoading = false
        this.isLoading = false
      }
    }
  }
})
